/**
* For flash notification use this model
* @author <bharat.chauhan@softwebsolutions.com>
* @param message <string>, type <string>
* @return Json Response
* */
export class Notification {
    constructor(public type: string = '',
        public message: string = '') {
    }
}
/**
* For flash notification use this service
* @author <bharat.chauhan@softwebsolutions.com>
* @return Json Response
* */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
@Injectable()
export class NotificationService {
    private _notifications = new Subject<Notification>();
    public noteAdded = this._notifications.asObservable();
    /* Add notification using add method */
    public add(notification: Notification) {
        this._notifications.next(notification);
    }
}
export class ResponseData {
    success: boolean;
    message: string;
}